<template>
  <div
    class="home-page"
    @click="closeDialogHandler"
  >
    <Header
      is-homepage
      :close-dialog="shouldCloseDialog"
    />
    <div class="content-wrapper">
      <div class="background-overlay" />
      <div class="content">
        <template v-for="item in items" :key="item.title">
          <RouterLink
            v-if="!item.disabled"
            :to="item.route"
            class="image-container"
          >
            <img
              :src="item.image"
              :alt="item.title"
              class="box-image cursor-pointer"
              @mouseover="hoveredItem = item.title"
              @mouseleave="hoveredItem = ''"
            >
            <img
              :src="item.hoverImage"
              :alt="item.title"
              class="box-image hover-image"
              :class="{ 'visible': hoveredItem === item.title }"
            >
          </RouterLink>

          <div
            v-else
            class="image-container disabled"
          >
            <img
              :src="item.image"
              :alt="item.title"
              class="box-image"
            >
          </div>
        </template>
      </div>
    </div>
    <VisitorCounter />
    <HomepageMenu v-if="authStore.isAuthenticated" />
  </div>
</template>

<script setup>
import oscImg from '@/assets/jkt/HomePage/OSC.png'
import pbtImg from '@/assets/jkt/HomePage/PBT.png'
import ahliMajlisImg from '@/assets/jkt/HomePage/ahliMajlis.png'
import cctvImg from '@/assets/jkt/HomePage/cctv.png'
import comingImg from '@/assets/jkt/HomePage/pbtpay.png'
import comingAImg from '@/assets/jkt/HomePage/comingA.png'
import ebookImg from '@/assets/jkt/HomePage/eBook.png'
import fogtImg from '@/assets/jkt/HomePage/fogt.png'
import iTegurImg from '@/assets/jkt/HomePage/iTegur.png'
import kolamImg from '@/assets/jkt/HomePage/kolam.png'
import lampuImg from '@/assets/jkt/HomePage/lampu.png'
import okuImg from '@/assets/jkt/HomePage/oku.png'
import pasarImg from '@/assets/jkt/HomePage/pasar.png'
import spahImg from '@/assets/jkt/HomePage/spah.png'
import tandasImg from '@/assets/jkt/HomePage/tandas.png'
import pasarAwam from '@/assets/jkt/HomePage/pasarAwam.png'
import premis from '@/assets/jkt/HomePage/premis.png'
import haiwan from '@/assets/jkt/HomePage/haiwan.png'
import sanitasi from '@/assets/jkt/HomePage/sanitasi.png'
import vektor from '@/assets/jkt/HomePage/vektor.png'
import kempen from '@/assets/jkt/HomePage/kempen.png'


// Hover images
import hoverOscImg from '@/assets/jkt/HomePage/OSC1.png'
import hoverPbtImg from '@/assets/jkt/HomePage/PBT1.png'
import hoverAhliMajlisImg from '@/assets/jkt/HomePage/ahliMajlis1.png'
import hoverCctvImg from '@/assets/jkt/HomePage/cctv1.png'
import hoverComing1Img from '@/assets/jkt/HomePage/pbtpay1.png'
import hoverComing2Img from '@/assets/jkt/HomePage/coming2.png'
import hoverEbookImg from '@/assets/jkt/HomePage/eBook1.png'
import hoverFogtImg from '@/assets/jkt/HomePage/fogt1.png'
import hoverITegurImg from '@/assets/jkt/HomePage/iTegur1.png'
import hoverKolamImg from '@/assets/jkt/HomePage/kolam1.png'
import hoverLampuImg from '@/assets/jkt/HomePage/lampu1.png'
import hoverOkuImg from '@/assets/jkt/HomePage/oku1.png'
import hoverPasarImg from '@/assets/jkt/HomePage/pasar1.png'
import hoverSpahImg from '@/assets/jkt/HomePage/spah1.png'
import hoverTandasImg from '@/assets/jkt/HomePage/tandas1.png'
import hoverpasarAwam from '@/assets/jkt/HomePage/pasarAwam1.png'
import hoverpremis from '@/assets/jkt/HomePage/premis1.png'
import hoverhaiwan from '@/assets/jkt/HomePage/haiwan1.png'
import hoverSanitasi from '@/assets/jkt/HomePage/sanitasi1.png'
import hovervektor from '@/assets/jkt/HomePage/vektor1.png'
import hoverkempen from '@/assets/jkt/HomePage/kempen1.png'

import { useAuthStore } from "@/store/auth"
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const authStore = useAuthStore()
const  shouldCloseDialog = ref(false)


//added by abdullah
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const closeDialogHandler = () => {

  shouldCloseDialog.value = true

  // alert(shouldCloseDialog.value)
}

const items = [
  { title: 'PBT', image: pbtImg, hoverImage: hoverPbtImg, route: 'utama/pbt' },
  { title: 'AHLI MAJLIS PBT', image: ahliMajlisImg, hoverImage: hoverAhliMajlisImg, route: 'utama/ahli-pbt' },
  { title: 'PASAR PBT', image: pasarImg, hoverImage: hoverPasarImg, route: 'utama/pasar-pbt' },
  { title: 'I-TEGUR', image: iTegurImg, hoverImage: hoverITegurImg, route: 'utama/pbtcare' },
  { title: 'pasarAwam', image: pasarAwam, hoverImage: hoverpasarAwam, route: 'utama/pasar-awam'  },
  { title: 'premis', image: premis, hoverImage: hoverpremis, route: 'utama/kesihatan'  },
  { title: 'haiwan', image: haiwan, hoverImage: hoverhaiwan, route: 'utama/haiwan-terbiar'  },
  { title: 'sanitasi', image: sanitasi, hoverImage: hoverSanitasi, route: 'utama/sanitasi'  },
  // { title: 'sanitasi', image: sanitasi, hoverImage: hoverSanitasi, route: '', disabled: true },
  { title: 'vektor', image: vektor, hoverImage: hovervektor, route: 'utama/vektor'  },
  { title: 'kempen', image: kempen, hoverImage: hoverkempen, route: 'utama/kempen'  },
  { title: 'TANDAS AWAM PBT', image: tandasImg, hoverImage: hoverTandasImg, route: 'utama/tandas-awam' },
  { title: 'PENYALAHGUNA PAKIR OKU', image: okuImg, hoverImage: hoverOkuImg, route: 'utama/oku' },
  { title: 'SPAH', image: spahImg, hoverImage: hoverSpahImg, route: 'utama/spah' },
  { title: 'CCTV', image: cctvImg, hoverImage: hoverCctvImg, route: 'utama/cctv' },
  { title: 'LAMPU JALAN', image: lampuImg, hoverImage: hoverLampuImg, route: 'utama/lampu-jalan' },
  { title: 'FOGT', image: fogtImg, hoverImage: hoverFogtImg, route: 'utama/fogt' },
  { title: 'KOLAM RENANG', image: kolamImg, hoverImage: hoverKolamImg, route: 'utama/kolam-renang' },
  { title: 'OSC 3.0 PLUS ONLINE', image: oscImg, hoverImage: hoverOscImg, route: 'utama/osc' },
  { title: 'COMING1', image: comingImg, hoverImage: hoverComing1Img, route: 'utama/pbtPay' },
  { title: 'E-BOOK', image: ebookImg, hoverImage: hoverEbookImg, route: 'utama/e-book' },

  // { title: 'COMING2', image: comingAImg, hoverImage: hoverComing2Img, route: '' },
]

const hoveredItem = ref('')
</script>

<style scoped>
.home-page {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-attachment: fixed;
  background-image: url("../assets/jkt/HomePage/background.png");
  background-position: center;
  background-size: cover;
  color: white;
  min-block-size: 100vh;
}

header {
  z-index: 2;
  padding: 10px;
  inline-size: 100%;
}

.underline {
  border: 2px solid #fff;
  inline-size: 600px;
  margin-block: 0;
  margin-inline: auto;
}

.content-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 20px;
  inline-size: 100%;
  
}

.background-overlay {
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  padding: 15px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  width: 100%;
  max-width: 1100px; /* enough space for 4 columns */
  left: 50%;
  transform: translateX(-50%);
  top: 10px;
  bottom: 10px;
}

.content {
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns */
  grid-auto-rows: auto;
  gap: 20px;
  width: 100%;
  max-width: 800px; /* match overlay */
  padding: 20px;
  box-sizing: border-box;
}


.image-container {
  position: relative;
  margin: auto;
  max-inline-size: 300px;
}

.box-image {
  block-size: auto;
  inline-size: 100%;
  transition: opacity 0.3s ease-in-out;
}

.hover-image {
  position: absolute;
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.image-container:hover .hover-image {
  opacity: 1;
}


@media (max-width: 3000px) {
  .background-overlay {
    width: 40%;
    max-width: 1150px;
    padding: 15px;
  }

  .content {
    gap: 25px;
  }


  .image-container {
    max-width: 300px;
  }
}


@media (max-width: 2000px) {
  .background-overlay {
    width: 70%;
    max-width: 800px;
    padding: 15px;
  }

  .content {
    grid-template-columns: repeat(4, 1fr);
  
  }

  .image-container {
    max-width: 160px;
  }
}

@media (max-width: 1080px) {
  .background-overlay {
    width: 90%;
    max-width: 800px;
    padding: 15px;
  }

  .content {
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
  }

  .image-container {
    width: 90%;
    max-width: 180px;
  }

  .box-image {
    width: 100%;
    height: auto;
  }
}


@media (max-width: 768px) {
  .background-overlay {
    width: 75%;
    max-width: 600px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    justify-items: center;
    align-items: center;
    width: 100%;
    max-width: 70%;
  }

  .image-container {
    width: 90%;
    max-width: 220px;
  }
}



@media (max-width: 480px) {
  .background-overlay {
    width: 50%;
    max-width: 350px;
    padding: 15px;
  }

  .content {
    grid-template-columns: 1fr;
    gap: 12px;
    justify-items: center;
  }

  .image-container {
    max-width: 120px;
    width: 100%;
  }

  .box-image {
    width: 100%;
    height: auto;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
